import middleware from "../../middleware";
class WeaCustomNew extends React.Component {
  render() {
    return this.props.children;
  }
}

const Com = middleware(WeaCustomNew, "WeaCustomNew");
export default Com;



// WEBPACK FOOTER //
// ./ecology9/wea-custom-new/index.js